module.exports = __webpack_public_path__ + "static/media/padre-pio-site-768x591.6242b8f0.jpg";